import { render, staticRenderFns } from "./ReportMobileGroceries.vue?vue&type=template&id=8f039db8"
import script from "./ReportMobileGroceries.vue?vue&type=script&lang=js"
export * from "./ReportMobileGroceries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports